import React from 'react'
import PropTypes from 'prop-types'
import { identity, isEmpty } from 'lodash-es'
import { Message } from '@paypalcorp/worldready-react'
import {
  goToCardManagementFlow,
  returnToOrigin,
  shouldReturnToCardManagement,
} from 'utils/navigate'
import { connect } from 'react-redux'
import { getRetryErrorContentId, getActionName } from 'utils/content'
import * as fpti from 'utils/fpti'
import { resetCardRequest } from 'utils/card'
import { Button, HourglassIcon, Link } from '@paypalcorp/pp-react'
import { resetFetchRetry } from '@/features/ui/ui-slice'
import { isNewFlowModal } from 'utils/flow'
import IconPage from 'components/common/IconPage'
import COMMON_FPTI_TAGS from '@/constants/fpti-tags/common'
import { showLoadingSpinner } from '../../actions/common'
import { serverData } from 'utils/server-data'

let flowName = '@flow'
let fptiPage = `@flow:retryError`
const fptiRetryLaterBtn = 'retryLaterBtn'
const { retryErrorActivityTags } = COMMON_FPTI_TAGS

class RetryError extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    resetCardRequest: PropTypes.func.isRequired,
    resetFetchRetry: PropTypes.func.isRequired,
    actionType: PropTypes.string,
    legalProductName: PropTypes.string,
    navProps: PropTypes.shape({
      onClose: PropTypes.func,
    }),
    flowInstanceId: PropTypes.string,
    fptiEntryPoint: PropTypes.string,
    errorType: PropTypes.string,
    errorMessage: PropTypes.string,
    showLoadingSpinner: PropTypes.func.isRequired,
    card: PropTypes.object,
  }

  UNSAFE_componentWillMount() {
    flowName = getActionName(this.props.actionType)
    fptiPage = fptiPage.replace('@flow', flowName)
    fpti.startCPLTracking(fptiPage)
  }

  componentDidMount() {
    const { flowInstanceId, fptiEntryPoint, errorType, errorMessage } = this.props
    const { page, ...rest } = retryErrorActivityTags(flowName)
    fpti.logActivity(page, rest)
    fpti.recordImpression(fptiPage, {
      flowInstanceId,
      fptiEntryPoint,
      errorType,
      errorMessage,
    })
    fpti.endCPLTracking()
  }

  handleTryAgainLater = () => {
    fpti.recordClick(fptiPage, fptiRetryLaterBtn)

    if (shouldReturnToCardManagement()) {
      goToCardManagementFlow(this.props.card, {}, { dispatch: this.props.dispatch })
      return
    }

    if (isNewFlowModal()) {
      returnToOrigin(this.props.dispatch, { endFlow: true })
      return
    }

    if (this.props.navProps && this.props.navProps.onClose) {
      this.props.navProps.onClose()
    } else {
      this.props.resetCardRequest()
      this.props.showLoadingSpinner()
      goToCardManagementFlow(this.props.card)
    }
  }

  render() {
    const { actionType, legalProductName: legalProductNameProp } = this.props
    
    // Derive legalProductName from serverData if not provided or empty
    const country = serverData.locality?.country
    // eslint-disable-next-line i18n-scan/no-country-dependency
    const legalProductName = legalProductNameProp || (country === 'GB' ? 'card' : 'product')
    
    const contentProps = {
      legalProductName,
      helpLink: (text) => <Link href="/smarthelp">{text}</Link>,
    }

    return (
      <IconPage
        data-testid="retry-error-page"
        icon={<HourglassIcon size="xl" color="sysColorPrimaryMain" />}
        headerId={getRetryErrorContentId('header', actionType)}
        contentId={getRetryErrorContentId('content', actionType)}
        contentProps={contentProps}
        wrapWithModalContent
      >
        <Button data-testid="retry-later-button" onClick={this.handleTryAgainLater}>
          <Message id="error.button.tryAgainLater" />
        </Button>
      </IconPage>
    )
  }

  componentWillUnmount() {
    if (isNewFlowModal()) {
      this.props.resetFetchRetry()
    } else {
      this.props.resetCardRequest()
    }
  }
}

const stateProps = (state, ownProps) => {
  const { fetchRetry } = ownProps.fetchingState ? ownProps.fetchingState : state.card || {}
  const card = state[ownProps.flowName || '']?.card || {}
  const { actionType } = fetchRetry || {}
  return { actionType, ...(!isEmpty(card) && { card }) }
}

const actionProps = {
  resetCardRequest,
  resetFetchRetry,
  dispatch: identity,
  showLoadingSpinner,
}

export default connect(stateProps, actionProps)(RetryError)
